module.exports = __webpack_public_path__ + "img/active-campaign.3aaccf6f.png";